module.exports = __webpack_public_path__ + "static/img/XC20.bca71cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/XC20.png
// module id = ArLm
// module chunks = 2